export default __webpack_public_path__ + "static/media/jrc_logo_main.da64068e.ai";